import React, { useState, useEffect } from 'react'
import { getApiTargetInfo } from 'core'
import { connect } from 'react-redux'
import CommonScreen from 'admin/component/CommonScreen'
import { toSelectionColProps } from '@integec/grid-tools/lib/utils'

import { strCol } from '@integec/grid-tools/lib/cols'
import {
  deleteSolarUSerPlantAccess,
  getSolarPlant,
  getSolarUSerPlantAccess,
  getUsers,
  updateSolarUSerPlantAccess,
} from 'api/pgads'
import { modifiedDateCol, modifierCol } from 'core/HeaderColTypeProps'
import { Label } from 'core/screen-util'
import { Button, Select } from 'antd'
import RA from 'ramda'

const title = 'Solar User Access Right'

const SolarUserAccess = ({ apiTargetInfo }) => {
  const [insertEvent, setInsertEvent] = useState(false)
  const [PlantIdMap, setPlantIdMap] = useState({})
  const [plantList, setPlantList] = useState([])
  const [userList, setUserList] = useState([])
  const [userIdNameMap, setUserIdNAmeMap] = useState({})

  useEffect(
    _ => {
      getUsers(apiTargetInfo)().fork(
        _ => _,
        users => {
          setUserList(
            RA.sortBy(r => r.firstName || r.lastName || r.userName)(users)
          )
          const tplntIdMap = RA.compose(
            RA.fromPairs,
            RA.map(user => [
              user.userName,
              `${user.firstName} ${user.lastName || ''} (${user.userName})`,
            ])
          )(users)
          setUserIdNAmeMap(tplntIdMap)
        }
      )
      getSolarPlant(apiTargetInfo).fork(
        _ => _,
        data => {
          setPlantList(RA.sortBy(d => d.plantName || d.plantId)(data))
          const tplntIdMap = RA.compose(
            RA.fromPairs,
            RA.map(t => [t.plantId, t.plantName])
          )(data)
          setPlantIdMap(tplntIdMap)
        }
      )
    },
    [apiTargetInfo]
  )

  const InsertComp = ({ insertData = {}, setInsertData, onAdd, onCancel }) => {
    return (
      <div
        style={{
          display: 'grid',
          gridTemplateColumns: '80px 250px 100px 250px 100px 250px',
          gap: 10,
        }}
      >
        <div>
          <Label style={{ display: 'inline', float: 'right' }}>Plant :</Label>
          <span style={{ color: 'red', marginRight: '2px', float: 'right' }}>
            *
          </span>
        </div>
        <Select
          id="plant"
          showSearch
          value={insertData.plantId}
          onChange={value => setInsertData({ ...insertData, plantId: value })}
          filterOption={(input, option) =>
            option.props.children.toLowerCase().indexOf(input.toLowerCase()) >=
            0
          }
        >
          {plantList?.map(({ plantId, plantName }) => (
            <Select.Option key={plantId} value={plantId}>
              {plantName}
            </Select.Option>
          ))}
        </Select>
        <div>
          <Label style={{ display: 'inline', float: 'right' }}>
            User Name :
          </Label>
          <span style={{ color: 'red', marginRight: '2px', float: 'right' }}>
            *
          </span>
        </div>
        <Select
          data-cy="select"
          value={insertData.userName}
          onChange={userName => setInsertData({ ...insertData, userName })}
          showSearch
          filterOption={(input, option) =>
            option.props.children.toLowerCase().indexOf(input.toLowerCase()) >=
            0
          }
        >
          {userList?.map(u => (
            <Select.Option value={u.userName} key={u.userName} data-cy="select">
              {userIdNameMap[u.userName]}
            </Select.Option>
          ))}
        </Select>

        <div>
          <Label style={{ display: 'inline', float: 'right' }}>
            Access Right :
          </Label>
        </div>
        <Select
          id="accessRight"
          value={insertData.accessRight}
          onChange={value =>
            setInsertData({ ...insertData, accessRight: value })
          }
        >
          <Select.Option key="R" value="R">
            READ
          </Select.Option>
          <Select.Option key="W" value="W">
            WRITE
          </Select.Option>
        </Select>
        <div>
          <></>
        </div>
        <div
          style={{
            display: 'grid',
            gridTemplateColumns: '1fr 1fr 1fr',
            gap: 5,
            gridColumnStart: '5',
            gridColumnEnd: 'span 2',
          }}
        >
          <Button type="primary" onClick={() => onAdd(true)}>
            Add
          </Button>
          <Button type="primary" onClick={() => onAdd(false)}>
            Add & Hide
          </Button>
          <Button type="danger" onClick={onCancel}>
            Cancel
          </Button>
        </div>
      </div>
    )
  }

  const SolarUSerAccessHeaders = [
    strCol({
      ident: 'plantId',
      display: 'Plant',
      isKey: true,
      width: 250,
      // ellipsis: true,
      // alignment: 'left',
      sortOrder: 'asc',
      ...toSelectionColProps(PlantIdMap),
    }),
    strCol({
      ident: 'userName',
      display: 'User Name',
      isKey: true,
      sortOrder: 'asc',
      width: 400,
      ...toSelectionColProps(userIdNameMap),
    }),
    strCol({
      ident: 'accessRight',
      display: 'Access Right',
      isRequired: true,
      sortOrder: 'asc',
      ...toSelectionColProps({ R: 'READ', W: 'WRITE' }),
    }),
    modifierCol,
    modifiedDateCol,
  ]

  return (
    <CommonScreen
      title={title}
      header={SolarUSerAccessHeaders}
      saveTask={updateSolarUSerPlantAccess}
      retrieveTask={getSolarUSerPlantAccess}
      deleteTask={deleteSolarUSerPlantAccess}
      autoRetrieve
      // widthOffset={50}
      insertComp={insertEvent && InsertComp}
      insertCompHeight={50}
      onInsertEvent={b => setInsertEvent(b)}
      autoFixColByKey={false}
      headerRowHeight={30}
      totalWidth={150 + 650 + 700 + 150}
      sortOptions={SolarUSerAccessHeaders}
      defaultInsertData={{ accessRight: 'R' }}
    />
  )
}

const mapStateToProps = state => ({
  apiTargetInfo: getApiTargetInfo(state),
})

export default connect(mapStateToProps)(SolarUserAccess)
